// eslint-disable-next-line @nx/enforce-module-boundaries
import { PartnershipItem } from '@sweetspot/club-portal-legacy/store/types'
import { DataTableColumnHeader, TableSortItem } from '@sweetspot/scramble-ds'
import { Tag } from '@sweetspot/scramble-ds/atoms'
import { ColumnDef } from '@tanstack/react-table'

export const columns = (
  t: (key: string) => string,
  sortItems: TableSortItem[],
  setSortItems: (items: TableSortItem[]) => void
): ColumnDef<PartnershipItem>[] => {
  return [
    {
      accessorKey: 'name',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} sortItems={sortItems} setSortItems={setSortItems} />
      ),
      meta: { title: t('name') },
      cell: ({ row }) => row.getValue('name'),
    },
    {
      accessorKey: 'type',
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      meta: { title: t('type') },
      cell: ({ row }) => t(row.getValue('type')),
      enableSorting: false,
    },
    {
      accessorKey: 'status',
      header: ({ column }) => <DataTableColumnHeader column={column} />,
      meta: { title: t('status') },
      cell: ({ row }) => (
        <Tag.Root variant={row.getValue('status')?.variant} className="mt-1 w-max px-2">
          {t(row.getValue('status')?.text)}
        </Tag.Root>
      ),
      enableSorting: false,
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id))
      },
    },
    {
      accessorKey: 'startDate',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} sortItems={sortItems} setSortItems={setSortItems} />
      ),
      meta: { title: t('startDate') },
      cell: ({ row }) => row.getValue('startDate'),
    },
    {
      accessorKey: 'endDate',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} sortItems={sortItems} setSortItems={setSortItems} />
      ),
      meta: { title: t('endDate') },
      cell: ({ row }) => row.getValue('endDate'),
    },
    {
      accessorKey: 'price',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} sortItems={sortItems} setSortItems={setSortItems} />
      ),
      meta: { title: t('price') },
      cell: ({ row }) => row.getValue('price'),
    },
  ]
}
